import React, { useState } from "react";
import { Form, Input, Modal } from "antd";
import dataFteService from "../../services/dataFte.service";
import Swal from "sweetalert2";
const ChangeDeputyDean = (props: { name: string }) => {
  const { name } = props;
  const [visible, setVisible] = useState(false);
  const handleCancel = () => {
    setVisible(false);
  };
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
  };

  const onFinish = async (values: { NewName: string }) => {
    console.log(values.NewName);
    await dataFteService
      .updateDeputyDean(values.NewName)
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleCancel();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };
  return (
    <>
      <button onClick={showModal} className="btn btn-info btn-sm text-white">
        <i className="bi bi-pencil-square"></i> แก้ไขชื่อรองคณบดี
      </button>
      <Modal
        visible={visible}
        title="ตั้งค่ารายวิชาที่ต้องส่งเอกสาร"
        onCancel={handleCancel}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={form.submit}
          >
            แก้ไขข้อมูล
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => form.resetFields()}
          >
            รีเซ็ต
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleCancel}
          >
            Close
          </button>,
        ]}
      >
        <Form
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          form={form}
          initialValues={{ NewName: name }}
        >
          <Form.Item
            name={"NewName"}
            rules={[
              {
                required: true,
                message: "กรุณาเลือกรายวิชากด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ChangeDeputyDean;
